// extracted by mini-css-extract-plugin
module.exports = {"root":"Notes_root__1zwgj","notes":"Notes_notes__1Kobw","note":"Notes_note__2JUBz","markdown":"Notes_markdown__37taN"};